import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

const categoryIcons: Record<string, string> = {
  all: 'ri-grid-fill',
  action: 'ri-sword-fill',
  comedy: 'ri-emotion-laugh-fill',
  scifi: 'ri-rocket-fill',
  romance: 'ri-heart-fill',
  horror: 'ri-ghost-fill',
  animation: 'ri-palette-fill',
  documentary: 'ri-earth-fill',
  war: 'ri-shield-flash-fill',
  mystery: 'ri-search-eye-line',
};

export default function CategoryGrid() {
  const displayCategories = categories.slice(0, 8);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50">
              电影分类
            </h2>
            <p className="text-sm text-foreground-600 mt-1">探索不同类型的精彩影片</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-4 gap-4 md:gap-5">
            {displayCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group bg-background-50 rounded-lg p-5 md:p-6 border border-background-300/40 hover:border-primary-500/40 transition-all duration-300 cursor-pointer"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-accent-100/70 mb-3 md:mb-4 group-hover:bg-accent-500/20 transition-colors duration-300">
                  <i className={`${categoryIcons[cat.slug] || 'ri-movie-fill'} text-accent-500 text-lg md:text-xl`}></i>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-200 group-hover:text-primary-500 transition-colors duration-200">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-600 mt-1">
                  海量高清资源
                </p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}